import {
  ColumnLayout,
  SpaceBetween,
} from '@cloudscape-design/components';
import PropTypes from 'prop-types';
import React from 'react';

const formatPidValue = (value) => (
  typeof value === 'number' ? value.toFixed(3).replace(/\.?0+$/, '') : '--'
);

const pidShape = PropTypes.shape({
  kp: PropTypes.number,
  tnSeconds: PropTypes.number,
  tvSeconds: PropTypes.number,
  tdSeconds: PropTypes.number,
  maxOvershoot: PropTypes.number,
});

function PidSideValues({
  label,
  values = null,
  showMaxOvershoot = true,
}) {
  return (
    <SpaceBetween size="xs">
      <div>{`${label} Kp: ${formatPidValue(values?.kp)}`}</div>
      <div>{`${label} Tn: ${formatPidValue(values?.tnSeconds)}`}</div>
      <div>{`${label} Tv: ${formatPidValue(values?.tvSeconds)}`}</div>
      <div>{`${label} Td: ${formatPidValue(values?.tdSeconds)}`}</div>
      {showMaxOvershoot && (
        <div>{`${label} Max Overshoot: ${formatPidValue(values?.maxOvershoot)}`}</div>
      )}
    </SpaceBetween>
  );
}

PidSideValues.propTypes = {
  label: PropTypes.string.isRequired,
  values: pidShape,
  showMaxOvershoot: PropTypes.bool,
};

function PidSnapshotDisplay({
  entry = null,
  showMaxOvershoot = true,
}) {
  return (
    <ColumnLayout columns={2} variant="text-grid">
      <PidSideValues
        label="Upper"
        values={entry?.upper}
        showMaxOvershoot={showMaxOvershoot}
      />
      <PidSideValues
        label="Lower"
        values={entry?.lower}
        showMaxOvershoot={showMaxOvershoot}
      />
    </ColumnLayout>
  );
}

PidSnapshotDisplay.propTypes = {
  entry: PropTypes.shape({
    upper: pidShape,
    lower: pidShape,
  }),
  showMaxOvershoot: PropTypes.bool,
};

export {
  formatPidValue,
  pidShape,
};

export default PidSnapshotDisplay;
